///<reference path="../../../../../../typings/index.d.ts" />
///<reference path="../../../../components/baseclasses/guid.ts" />
///<reference path="../module.ts" />
///<reference path="../../../../components/short-cuts/short-cuts-list.service.ts"/>
///<reference path="../../../../components/short-cuts/short-cuts.service.ts"/>
///<reference path="../../../../components/short-cuts/models/short-cuts-combination.model.ts"/>

import ShortCutGroup = Meevo.Components.ShortCuts.ShortCutGroup;
import IShortCutGroupItem = Meevo.Components.ShortCuts.IShortCutGroupItem;
import IShortCutGroup = Meevo.Components.ShortCuts.IShortCutGroup;
import ShortCutCombination = Meevo.Components.ShortCuts.ShortCutCombination;

declare var device;

angular.module('ApptBookApp').controller('AppointmentBookController', [
    '$scope',
    '$http',
    '$q',
    'restServer',
    '$location',
    '$rootScope',
    'appointmentBookBuilderService',
    'appointmentBookGlobalsService',
    'appointmentBookHelperService',
    'appointmentBookActionsService',
    'Meevo.Plugins.AppointmentBook.Services.AppointmentBookModalService',
    'Meevo.Plugins.AppointmentBook.Services.AppointmentBookFilterActionsService',
    'meevo.components.short-cuts.ShortCutsService',
    'meevo.components.short-cuts.ShortCutsListService',
    '$timeout',
    'meevo.ContextParams',
    'meevo.components.common.DataService',

    function (
        $scope,
        $http,
        $q,
        restServer,
        $location,
        $rootScope,
        builder,
        globals,
        helper,
        actions,
        modal, //TODO: use type Meevo.Plugins.AppointmentBook.Services.AppointmentBookModalService,
        filterActions: Meevo.Plugins.AppointmentBook.Services.AppointmentBookFilterActionsService,
        shortKeysService: Meevo.Components.ShortCuts.IShortCutsService,
        shortKeysListService: Meevo.Components.ShortCuts.IShortCutsListService,
        $timeout,
        contextParams: Meevo.ContextParamsService,
        dataService: Meevo.Components.BaseClasses.IDataService
    ) {
        $scope.globals = globals;
        $scope.modal = modal;
        $scope.actions = actions;
        $scope.builder = builder;
        $scope.helper = helper;
        $scope.meevoSecurityKeys = Meevo.Components.Common.SecurityKeys;
        filterActions.setBuilderService(builder);
        $scope.filterActions = filterActions;
        $scope.checkAppointmentFilters = checkAppointmentFilters;
        globals.setDefaults();
        filterActions.setDefaults();

        var watchDeregisterFn = null;

        // TODO: Inject the state names constant into this controller
        let appointmentBookStateName = 'appointmentBook';

        $scope.$on("$destroy", ()=>{
            $scope.builder.stopTimeBarTimer();
        });

        function checkAppointmentFilters(location: string): boolean {
            if (location == 'MainFilter') {
                if (
                    (filterActions.filteredServices && filterActions.filteredServices.length > 0) ||
                    (filterActions.filteredEmployees && filterActions.filteredEmployees.length > 0) ||
                    (filterActions.filteredEmployeeCategories && filterActions.filteredEmployeeCategories.length > 0) ||
                    (filterActions.filteredResources && filterActions.filteredResources.length > 0) ||
                    (filterActions.gender && (filterActions.gender === Meevo.Model.GenderEnum.Female || filterActions.gender === Meevo.Model.GenderEnum.Male))
                ) {
                    return true;
                }
            } else if (location == 'SecondaryFilter') {
                if (globals.opacityFilterSelections) {
                    if (
                        JSON.stringify(angular.toJson(globals.opacityFilterSelections)) !==
                        JSON.stringify(angular.toJson(globals.opacityFilterSelectionsDefaults))
                    ) {
                        return true;
                    }
                }
            } else if (location == 'ResourceCountFilter') {
                return Meevo.Model.Guard.isSomething(filterActions.resourceCountResourceCatFilter);
            }
            return false;
        }
        function navigateToBookDate(appointmentDate: any): ng.IPromise<any> {
            var apptDateMoment = moment(appointmentDate);
            if (appointmentDate != null && apptDateMoment.isValid()) {
                var apptBookDate = filterActions.dateString;
                apptBookDate.setHours(0, 0, 0, 0);

                if (appointmentDate.valueOf() != apptBookDate.valueOf()) {
                    filterActions.recalculateDate(apptDateMoment.toDate());
                    filterActions.dateChanged();
                }
            }

            var p = $q.defer();
            var resolveApptBookWatcher = function () {
                p.resolve();
                if (watchDeregisterFn) {
                    watchDeregisterFn();
                    watchDeregisterFn = null;
                }
            };

            watchDeregisterFn = $scope.$watch(
                function () {
                    return globals.appointmentBookLoaded;
                },
                function (newValue, oldValue, scope) {
                    if (newValue) {
                        resolveApptBookWatcher();
                    }
                }
            );

            if (globals.appointmentBookLoaded) {
                resolveApptBookWatcher();
            }

            return p.promise;
        }

        function processAction(params: any, isInitialLoad: boolean = false) {
            if (params.actionState == null) {
                filterActions.applyParams(params, isInitialLoad);
                return;
            }

            switch (params.actionState) {
                case Meevo.Model.AppointmentBookState.EditAppointment:
                    navigateToBookDate(params.actionStatePayload.appointmentDate).then(() => {
                        $timeout(() => {
                            actions.openAppointment(params.actionStatePayload, false);
                        });
                    });
                    break;

                case Meevo.Model.AppointmentBookState.DeleteAppointment:
                    navigateToBookDate(params.actionStatePayload.appointmentDate).then(() => {
                        actions.deleteAppointment(params.actionStatePayload);
                    });
                    break;

                case Meevo.Model.AppointmentBookState.RebookAppointment:
                    $timeout(() => {
                        actions.manuallyRebook(params.actionStatePayload.appointmentServices);
                        filterActions.applyParams(params, isInitialLoad);
                    }, 400);
                    break;

                default:
                    filterActions.applyParams(params, isInitialLoad);
                    break;
            }
        };

        /**
         * Listener for availability for pending appointments
         */
        $scope.$on(Meevo.Components.Common.Messages.PENDING_MESSAGES, (event, msg) => {
            // Wrap the call in $apply so Angular knows to call $digest
            $scope.$apply(() => {
                var pendingAppointmentCount = msg;
                if (msg && typeof msg == 'string') {
                    try {
                        pendingAppointmentCount = JSON.parse(msg);
                    } catch (e) { }
                }
                filterActions.pendingAppointmentCount = pendingAppointmentCount;
            });
        });

        $scope.$on(Meevo.Components.Common.Messages.NO_SHOW, (event, msg) => {
            JSON.parse(msg).forEach(appointmentService => {
                helper.setAppointStateIndicator(
                    appointmentService.guid,
                    Meevo.Model.AppointStateEnum.NoShow,
                    null,
                    appointmentService.entityVersion
                );
            });
        });

        /**
         * Listener for state change to bind and unbind the hotkeys
         * We need to do this for cases where we're using sticky state since the controller will still be alive
         * even when this isn't the current context.
         */
        $scope.$on('$stateChangeSuccess', (event, toState, toParams, fromState, fromParams) => {
            if (toState.name === appointmentBookStateName) {
                onRouteActive();
                $timeout(() => {
                    builder.continue();

                    $timeout(() => {
                        helper.setHeaderCellRootWidth();
                    });
                });
            } else if (fromState.name === appointmentBookStateName) {
                onRouteInactive();
                builder.pause();
            }
        });

        $scope.$on(Meevo.Components.Common.Messages.APPLY_PARAMS_TO_CONTEXT, (event, state, params) => {
            if (state.name !== appointmentBookStateName) {
                return;
            }

            $timeout(() => {
                processAction(params);
            });
        });

        $scope.$on('appointmentServicesCancelled', (event, state, params) => {
            if (state.name == appointmentBookStateName) {
                $scope.actions.removeAppointDetailsFromBook(null, null, params.affectedAppointmentServiceIds);
            }
        });

        $scope.$on(Meevo.Components.Common.Messages.CLOSE_DAF_FORM, (event, state, params) => {
            $("#divAppointmentBookScrollContainer").css("overflow", "");
        });

        // TODO: Review where we ultimately want to store hotkey combos
        let hotKeyPrefix = `alt+shift+`;
        let employeeCategories;
        let appointmentsShortKeysGroup: IShortCutGroup;
        const shortKeyGroupItems: IShortCutGroupItem[] = [
            {
                shortCutName: 'APPOINTMENT_BOOK_TODAY',
                callback: () => filterActions.today()
            },
            {
                shortCutName: 'APPOINTMENT_BOOK_EDITOR',
                callback: () => $scope.actions.showEditor(globals.appointmentDataTypeId),
            },
            {
                shortCutName: 'APPOINTMENT_BOOK_CLEAR_FILTERS',
                callback: () => {
                    filterActions.clearFilters();
                    filterActions.filterBook();
                },
            },
            {
                shortCutName: 'APPOINTMENT_BOOK_PRECISION_TIMING',
                callback: () => filterActions.togglePrecisionView()
            }
        ];

        function activateHotKeys() {
            appointmentsShortKeysGroup = new ShortCutGroup(shortKeyGroupItems, {
                noun: Meevo.Model.NounEnum.AppointmentBook,
            });
            shortKeysService.activateGroup(appointmentsShortKeysGroup);
        }

        function bindHotkeys() {
            bindWeeks();

            if (!employeeCategories) {
                employeeCategories = [];
                dataService
                    .getListPaged('employeeCategory', {
                        pageNumber: 0,
                        itemsPerPage: 100000,
                        criteria: {},
                    })
                    .then(data => {
                        employeeCategories = data;
                        bindEmployeeCatHotKeys();
                    })
                    .finally(() => {
                        activateHotKeys();
                    });
            } else {
                bindEmployeeCatHotKeys();
                activateHotKeys();
            }
        }

        function bindWeeks() {
            for (let i = 0; i <= 9; i++) {
                let numberOfWeeks = i;
                if (i == 0) {
                    numberOfWeeks = 10;
                }

                const shortCutKeyName: string = `APPOINTMENTS_NUMBER_OF_WEEKS_${numberOfWeeks}`;

                shortKeysListService.update(
                    shortCutKeyName,
                    new ShortCutCombination(`${hotKeyPrefix}${i}`, {
                        description: `Go ahead ${numberOfWeeks} weeks`
                    })
                );

                const shortCutExists = _(shortKeyGroupItems).any(shortcut => shortcut.shortCutName == shortCutKeyName);

                if (shortCutExists) {
                    return;
                }

                shortKeyGroupItems.push({
                    shortCutName: shortCutKeyName,
                    callback: () => filterActions.weekJump(numberOfWeeks),
                });
            }
        }

        function bindEmployeeCatHotKeys() {
            employeeCategories.forEach((employeeCat: any) => {
                if (!employeeCat.shortcutKey) {
                    return;
                }

                if (employeeCat.shortcutKey.toUpperCase() == 'P') {
                    return;
                }

                const shortCutKeyName: string = `EMPLOYEE_CATEGORIES_CUSTOM_${employeeCat.shortcutKey}`;

                shortKeysListService.update(
                    shortCutKeyName,
                    new ShortCutCombination(`${hotKeyPrefix}${employeeCat.shortcutKey.toLowerCase()}`, {
                        description: `Employee Cat: ${employeeCat.displayName}`,
                    })
                );

                const shortCutExists = _(shortKeyGroupItems).any(shortcut => shortcut.shortCutName == shortCutKeyName);

                if (shortCutExists) {
                    return;
                }

                shortKeyGroupItems.push({
                    shortCutName: shortCutKeyName,
                    callback: () => {
                        filterActions.updateFilters(
                            [{ id: employeeCat.id, displayName: employeeCat.displayName }],
                            [],
                            [],
                            null
                        );
                        filterActions.filterBook();
                    },
                });
            });
        }

        function unbindHotkeys() {
            shortKeysService.deactivateGroup(appointmentsShortKeysGroup);
        }

        /**
         * Called when the route/state/context for this controller is activated (i.e. switched to the corresponding context)
         */
        function onRouteActive() {
            bindHotkeys();
        }

        /**
         * Called when the route/state/context for this controller is made inactive (i.e. switched away from the corresponding context)
         */
        function onRouteInactive() {
            unbindHotkeys();
        }

        // Call this for when the constructor initializes
        onRouteActive();

        // Check for incoming parameters in the Meevo ContextParams service.
        // This is an intentional replacement of $stateParams.
        if (contextParams.params) {
            processAction(contextParams.params, true);
        }

        function refreshColumnsForSave(affectedColumns, forceRedrawIfVisible = false, forMove = false) {
            // determine if the entire book needs to be refreshed due to an unscheduled employee
            // now having an appointment service within the displayed date range
            var startDate = moment($scope.filterActions.dates[0]);
            var endDate = moment($scope.filterActions.dates[$scope.filterActions.dates.length - 1]);

            var columnsVisibility = _.map(affectedColumns, function (affectedColumn: any) {
                if (!affectedColumn.entityId) {
                    return { notOnBook: false, visibleOnBook: false };
                }

                var startOfAffectedDay = affectedColumn.date.startOf('day');
                var affectedEntityId = affectedColumn.entityId.replace(/-/g, '');

                var isShownOnBook = _.any(globals.columnBookings, function (displayedColumn: any) {
                    return (
                        affectedEntityId ===
                            (displayedColumn.employeeId || displayedColumn.resourceId).replace(/-/g, '') &&
                        moment(displayedColumn.date, globals.columnDateFormat).isSame(startOfAffectedDay)
                    );
                });

                return {
                    notOnBook:
                        (startOfAffectedDay.isSame(startDate) || startOfAffectedDay.isAfter(startDate)) &&
                        (startOfAffectedDay.isSame(endDate) || startOfAffectedDay.isBefore(endDate)) &&
                        !isShownOnBook,
                    visibleOnBook:
                        (startOfAffectedDay.isSame(startDate) || startOfAffectedDay.isAfter(startDate)) &&
                        (startOfAffectedDay.isSame(endDate) || startOfAffectedDay.isBefore(endDate)) &&
                        isShownOnBook,
                };
            });

            if (
                _.any(columnsVisibility, function (columnVis: any) {
                    return columnVis.notOnBook;
                })
            ) {
                // refresh the book, including all filters and skip looking for individual columns to refresh
                $scope.filterActions.clearFilters();
                $scope.filterActions.filterBook();
                return;
            } else if (forceRedrawIfVisible) {
                if (
                    _.any(columnsVisibility, function (columnVis: any) {
                        return columnVis.visibleOnBook;
                    })
                ) {
                    $scope.filterActions.filterBook();
                    return;
                }
            }

            // create a new filter for column refresh
            var columnIds = [];
            var filters = new Meevo.Plugins.AppointmentBook.Models.AppointmentBookFilters();
            filters.displayNoShows = filterActions.displayNoShows;
            affectedColumns.forEach(affectedColumn => {
                var date = affectedColumn.date.format('M-D-YYYY');
                if (affectedColumn.entityId) {
                    if (globals.isEmployeeView) {
                        var columnId = helper.GetColumnId(date, affectedColumn.entityId);
                        if (columnIds.indexOf(columnId) == -1) {
                            if (_.where(globals.columnBookings, { columnId: columnId }).length > 0) {
                                /*
                                if (!forMove) {
                                    // appears redundant with AppointmentBookBuilderService clearColumns
                                    // restore this if things go nuts when refreshing columns/save
                                    console.log('refreshColumnsForSave', columnId);
                                    $('#' + columnId).empty();
                                }
                                */
                                let booking: any = _.findWhere(globals.columnBookings, {
                                    columnId: helper.GetColumnId(date, affectedColumn.entityId),
                                });
                                filters.dimensionDates.push(<
                                    Meevo.Plugins.AppointmentBook.Models.EmployeeDimensionDate
                                >{
                                    entityId: affectedColumn.entityId,
                                    date: date,
                                    isShared: booking.isShared,
                                    managedByLocationId: booking.managedByLocationId,
                                });
                            }
                            columnIds.push(columnId);
                        }
                    } else {
                        var columnBookingDate = affectedColumn.date.format('M/D/YYYY');
                        let resourceUnitColumns: any = _.where(globals.columnBookings, {
                            resourceId: affectedColumn.entityId,
                            date: columnBookingDate,
                        });
                        for (let resourceUnitColumn of resourceUnitColumns) {
                            if (columnIds.indexOf(resourceUnitColumn.columnId) == -1) {
                                /*
                                if (!forMove) {
                                    // appears redundant with AppointmentBookBuilderService clearColumns
                                    // restore this if things go nuts when refreshing columns/save
                                    console.log('refreshColumnsForSave', columnId);
                                    $('#' + resourceUnitColumn.columnId).empty();
                                }
                                */
                                filters.dimensionDates.push({
                                    entityId: resourceUnitColumn.resourceUnitId,
                                    date: date,
                                });
                                columnIds.push(resourceUnitColumn.columnId);
                            }
                        }
                    }
                }
            });

            if (filters.dimensionDates.length > 0) {
                restServer.LoadAppointmentBookData(
                    globals.isEmployeeView,
                    filters,
                    (response) => {
                        globals.onApptBookDataSuccess(response);
                        if (forMove) {
                            helper.recalculateScrollbarHeight();
                        }
                    }
                );
            }
        }

        //#region Watches
        $scope.$on('showMessage', function (event, args) {
            modal.showMessage(args.message, args);
        });

        $scope.$on('hideMessage', function (event, args) {
            modal.hideMessage();
        });

        $scope.$on('appointmentSaved', function (event, args) {
            if ($scope.filterActions.isGrouped) {
                if ($scope.globals.opacityFilterSelections.appointmentId === args.originalAppointmentId) {
                    $scope.globals.opacityFilterSelections.appointmentId = args.appointmentId;
                }
                $scope.filterActions.reGroup();
                return;
            }

            if (args.affectedColumns) {
                refreshColumnsForSave(args.affectedColumns, args.redrawApptBook, false);
            }
        });

        $scope.$on('blockSaved', function (event, args) {
            refreshColumnsForSave(args.affectedColumns, args.redrawApptBook);
        });

        $scope.$on('appointmentMoved', function (event, args) {
            if (globals.isEmployeeView) globals.onApptBookDataMoveSuccess(args.response, args.affectedColumns);
            else refreshColumnsForSave(args.affectedColumns, false, true);
        });

        $scope.$on('blockMoved', function (event, args) {
            if (globals.isEmployeeView) globals.onApptBookDataMoveSuccess(args.response, args.affectedColumns);
            else refreshColumnsForSave(args.affectedColumns, false, true);
        });

        $scope.$on('serverError', function (event, args) {
            modal.hideProcessingOverlay();
        });

        $scope.$on(Meevo.Components.Common.Messages.CLIENT_FIND_APPT_CHECKED_IN, function(
            event: angular.IAngularEvent,
            appointmentId: any,
            isMultipleCheckIn: boolean
        ) {
            if (isMultipleCheckIn) {
                restServer.getAppointment(appointmentId, false).then(result => {
                    if (result.data.services.length > 0) {
                        result.data.services.forEach(function (service) {
                            helper.setAppointStateIndicator(
                                service.id,
                                Meevo.Model.AppointStateEnum.CheckedIn,
                                Meevo.Model.AppointFinalStateEnum.None
                            );
                        });
                    }
                });
            } else {
                helper.setAppointStateIndicator(
                    appointmentId,
                    Meevo.Model.AppointStateEnum.CheckedIn,
                    Meevo.Model.AppointFinalStateEnum.None
                );
            }
        });

        $scope.$on(Meevo.Components.Common.Messages.CLIENT_FIND_APPT_CHECKED_OUT, function (
            event: angular.IAngularEvent,
            appointmentId: any,
            isMultipleCheckOut: boolean,
            transistionState: Meevo.Model.AppointStateEnum = null
        ) {
            if (isMultipleCheckOut) {
                restServer.getAppointment(appointmentId, false, true).then(result => {
                    if (result.data.services.length > 0) {
                        result.data.services.forEach(function (service) {
                            if (service.finalState === Meevo.Model.AppointFinalStateEnum.CheckedOut) {
                                helper.setAppointStateIndicator(
                                    service.id,
                                    service.transitionState,
                                    Meevo.Model.AppointFinalStateEnum.CheckedOut
                                );
                            }
                        });
                    }
                });
            } else {
                helper.setAppointStateIndicator(
                    appointmentId,
                    transistionState,
                    Meevo.Model.AppointFinalStateEnum.CheckedOut
                );
            }
        });

        //#endregion

        helper.detectPhoneMode();

        builder.initialize(() => {
            processAction(contextParams.params);
        });
    }
]);
